import io from "socket.io-client";

//export const socket = io({ path: "/socket.io" });


let socket;

export const initiateSocketConnection = () => {
  socket = io(
    { path: "/socket.io", 
      auth: {
        username: localStorage.getItem("user"), //await getUsername(),
        userId: localStorage.getItem("userId")
        //serverOffset: 0
      }
    }); //, autoConnect: false
  console.log(`Connecting socket desde initiateSocketConnection...`);
  return socket
}

